<div class="tw-overflow-y-auto">
  <section class="tw-p-5">
    <nav
      ngbNav
      #nav="ngbNav"
      class="nav-tabs border-bottom"
      [destroyOnHide]="false"
    >
      <ng-container ngbNavItem>
        <a ngbNavLink class="!tw-flex-center tw-w-1/2">
          <i class="mdi mdi-earth text-blue tw-mr-1 tw-text-3xl"></i>
          <span class="tw-mt-1 tw-mr-2 text-dark">{{
            "pages.sendingSystem.sendSmartSmsCreateRequest.sendSmartSmsAdvanceSearch.public"
              | translate
          }}</span>
        </a>
        <ng-template ngbNavContent>
          <div class="row sm:tw-w-[525px] md:tw-w-[623px] lg:tw-w-[786px]">
            <!-- state -->
            <div class="md:tw-w-1/2">
              <zones-select-search
                #setStates
                label="common.state"
                class="select-list__search tw-w-full"
                [id]="1"
                [control]="form?.get('stateControl')"
                [value]="stateId"
                (valueChange)="stateId = $event; onStateChange()"
              >
              </zones-select-search>
            </div>
            <!-- city -->
            <div class="md:tw-w-1/2">
              <zones-select-search
                #citySelectSearch
                label="common.city"
                class="select-list__search tw-w-full"
                [id]="stateId"
                [control]="form?.get('cityControl')"
                [value]="cityId"
                (valueChange)="onCityChange($event)"
              >
              </zones-select-search>
            </div>
            <!-- text -->
            <div class="md:tw-w-1/2">
              <mat-form-field
                class="select-list__search tw-w-full"
                appearance="outline"
              >
                <mat-label>{{
                  "pages.sendingSystem.sendSmartSmsCreateRequest.sendSmartSmsAdvanceSearch.publicSearch"
                    | translate
                }}</mat-label>
                <input matInput #searchInput />
                <mat-icon class="dark:tw-text-gray-300" matSuffix
                  >search</mat-icon
                >
              </mat-form-field>
            </div>
            <!-- category -->
            <div class="md:tw-w-1/2">
              <public-place-sub-category-select-search
                #categorySelectSearch
                label="pages.sendingSystem.sendSmartSmsCreateRequest.sendSmartSmsAdvanceSearch.category"
                class="select-list__search tw-w-full"
                [control]="form?.get('categoryControl')"
                [id]="categoryId"
                [value]="categoryId"
                (valueChange)="onCategoryChange($event)"
              >
              </public-place-sub-category-select-search>
            </div>
          </div>

          <div class="row tw-min-h-[197px]">
            <div
              class="tw-mt-4 border border-priamry tw-w-full tw-h-[152px] tw-overflow-y-auto tw-overflow-x-hidden"
              [class.d-none]="loadingPublic || isShowEmptyItems"
            >
              <div class="row">
                <div
                  class="sm:tw-w-1/3 tw-mt-1"
                  *ngFor="let item of suggestedListPublic"
                >
                  <div class="checkbox-section overflow-auto">
                    <mat-checkbox
                      class="example-margin"
                      id="chb-{{ item.id }}"
                      value="{{ item.id }}"
                      (change)="onSelectionPublic($event)"
                    >
                      {{ item.title }}
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tw-mt-4 border border-priamry tw-w-full tw-h-[152px] tw-overflow-y-auto tw-overflow-x-hidden tw-flex-center"
              [class.d-none]="!loadingPublic || isShowEmptyItems"
            >
              <div class="row">
                <div class="sm:tw-w-1/3 tw-mt-1">
                  <span>
                    <span
                      class="spinner-border spinner-border-sm fs-5"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Loading...</span>
                  </span>
                </div>
              </div>
            </div>

            <div
              class="tw-mt-4 tw-border-2 tw-border-dashed dark:tw-border-dark-100 rounded-md tw-w-full tw-h-[152px] tw-overflow-y-auto tw-overflow-x-hidden tw-flex-center"
              [class.d-none]="!isShowEmptyItems"
            >
              <div class="row">
                <span class="tw-text-gray-500 dark:tw-text-gray-300 tw-text-xl">
                  {{ "common.empty" | translate }}
                </span>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-container ngbNavItem>
        <a ngbNavLink class="!tw-flex-center tw-w-1/2">
          <i class="mdi mdi-account text-danger tw-mr-1 tw-text-3xl"></i>
          <span class="tw-mt-1 tw-mr-2 text-dark">
            {{
              "pages.sendingSystem.sendSmartSmsCreateRequest.sendSmartSmsAdvanceSearch.personal"
                | translate
            }}</span
          >
        </a>
        <ng-template ngbNavContent>
          <div class="row">
            <div class="tw-w-full">
              <public-place-selection-list
                (items)="onSelectionPersonal($event)"
                [values]="selectedListPersonalIds"
                searchLabel="pages.sendingSystem.sendSmartSmsCreateRequest.sendSmartSmsAdvanceSearch.searchInPersonalPlaces"
              >
              </public-place-selection-list>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </nav>
    <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>
  </section>
  <section class="tw-p-5">
    <div class="row">
      <div class="sm:tw-w-1/2">
        <fieldset>
          <legend
            class="tw-mt-4 border border-priamry bg-gradient-black !tw-text-[0.97rem] tw-whitespace-nowrap"
          >
            {{
              "pages.sendingSystem.sendSmartSmsCreateRequest.sendSmartSmsAdvanceSearch.selectedListPublic"
                | translate
            }}
          </legend>
          <div class="tw-h-[160px] tw-overflow-y-auto tw-overflow-x-hidden">
            <div class="row selected-items">
              <div
                class="sm:tw-w-1/2 tw-mt-1"
                *ngFor="let item of selectedListPublic"
              >
                <div
                  class="selected-item tw-cursor-pointer overflow-auto"
                  (click)="onRemovePublic(item.id)"
                >
                  <span
                    class="mdi mdi-trash-can-outline text-danger tw-ml-2 fs-4"
                  ></span>
                  <span class="tw-flex tw-items-center dark:tw-text-gray-300">{{
                    item.title
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="sm:tw-w-1/2">
        <fieldset>
          <legend
            class="tw-mt-4 border border-priamry bg-gradient-black !tw-text-[0.97rem] tw-whitespace-nowrap"
          >
            {{
              "pages.sendingSystem.sendSmartSmsCreateRequest.sendSmartSmsAdvanceSearch.selectedListPersonal"
                | translate
            }}
          </legend>
          <div class="tw-h-[160px] tw-overflow-y-auto tw-overflow-x-hidden">
            <div class="row selected-items">
              <div
                class="sm:tw-w-1/2 tw-mt-1"
                *ngFor="let item of selectedListPersonal"
              >
                <div
                  class="selected-item tw-cursor-pointer"
                  (click)="onRemovePersonal(item.id)"
                >
                  <span
                    class="mdi mdi-trash-can-outline text-danger tw-ml-2 fs-4"
                  ></span>
                  <span class="tw-flex tw-items-center dark:tw-text-gray-300">{{
                    item.title
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </section>
  <section class="tw-p-5">
    <div class="row tw-justify-end">
      <button
        class="btn btn-danger sm:tw-w-1/6 tw-mb-2 tw-mx-1"
        (click)="onClose()"
      >
        {{ "common.cancel" | translate }}
      </button>

      <button
        class="btn sm:tw-w-1/4 tw-mr-2 tw-mb-2 tw-mx-1"
        (click)="onSubmit()"
        [themeColor]="'btn'"
      >
        {{ "common.submit" | translate }}
      </button>
    </div>
  </section>
</div>
